module.exports = __webpack_public_path__ + "static/SharpSansNo1-Semibold-b2ead092123ec19c5918af43ab132353.woff";